<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html,body,#app{
 width: 100%;
 min-height: 100%;
 display: flex;

}
</style>
